import { assureurs } from '@/constants/grilleAssureursData';
import tutorielsVideoData from '@/constants/tutorielsVideoData';
import normalizeUrl from '@/utils/functions/normalizeUrl/normalizeUrl';

import type { OperationKey, TutorielOperation, TutorielVideo } from '@/types/videoTutorials';

interface VideoTutorials {
  catalogKey: string | undefined;
  tutorials: TutorielVideo[];
  operationTutorial: TutorielVideo | undefined;
}

const getVideoTutorials = (
  link: string | null | undefined,
  operation?: OperationKey | TutorielOperation
): VideoTutorials => {
  const normalizedLink = normalizeUrl(link);
  const catalogKey = normalizedLink
    ? assureurs.find((assureur) => normalizeUrl(assureur.link) === normalizedLink)?.assureur
    : undefined;
  const tutorials = (catalogKey && tutorielsVideoData[catalogKey]) || [];
  const tutorielOperation = operation === 'rachat/retrait' ? 'rachat' : operation;

  return {
    catalogKey,
    tutorials,
    operationTutorial: tutorials.find((tutorial) => tutorial.operation === tutorielOperation),
  };
};

export default getVideoTutorials;
